import api from '@services/api.service'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { authUrl } from '@store/slices/auth.slice'

export const login = createAsyncThunk(
  `${authUrl}/login`,
  async (params: { email: string; loginKey: string }) => {
    const response = await api.post(
      `${authUrl}login/`,
      {
        email: params.email,
        login_key: params.loginKey,
      },
      {
        withCredentials: false,
      }
    )

    if (response.status !== 200) {
      throw new Error('Error during login')
    }
    const userInfo = response.data.user_info
    return {
      username: userInfo.username,
      email: userInfo.email,
      ttl: userInfo['session-until'],
    }
  }
)

export const fetchUserdata = createAsyncThunk('auth/user', async () => {
  try {
    const response = await api.get(`${authUrl}user/`)

    const userInfo = response.data.user_info
    return {
      username: userInfo.username,
      email: userInfo.email,
      ttl: userInfo['session-until'],
    }
  } catch (e) {
    return null
  }
})

// getLoginToken thunk
export const fetchLoginToken = createAsyncThunk(
  'auth/fetchLoginToken',
  async (email: string) => {
    const response = await api.post(`${authUrl}login-token-request/`, {
      email: email,
    })

    if (response.status !== 200) {
      throw new Error('Error getting login token')
    }

    return response.data.message
  }
)

export const logout = createAsyncThunk('auth/logout', async () => {
  const response = await api.post(`${authUrl}logout/`)
  if (response.status !== 200) {
    throw new Error('Error getting login token')
  }

  return response.data.message
})
